import axios          from 'axios';
import {getAppLang, getUserToken} from "../../../../utils";
import { RESET_PASSWORD }   from "../../../../constants/api.constants";


export function resetPassword(params) {

    const requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'language' : getAppLang(),
            'authToken': getUserToken(),
        },
        body: {
            params: {
                email : params.email,
                key : params.key,
                password : params.password,
                password_confirmation : params.password_confirmation
            }
        }
    };


    return dispatch => {
        dispatch({
            type: 'RESET_PASSWORD',
            payload: axios.post(RESET_PASSWORD, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data)
        })
    }
}